import React, { useMemo } from 'react';
import { View, Heading, Text } from '@aws-amplify/ui-react';
export function useCustomSlots(logo) {
    return useMemo(function () { return ({
        Header: function () {
            return (React.createElement(View, { className: "ov-authenticator-logo" },
                React.createElement("img", { src: logo, alt: "" }),
                React.createElement(Heading, { className: "ov-authenticator-title", level: 3 }, "ProVision")));
        },
        ResetPassword: {
            Header: function () {
                return (React.createElement(React.Fragment, null,
                    React.createElement(Heading, { level: 3, className: "ov-authenticator-header" }, "Forgot your password?"),
                    React.createElement(Text, { className: "ov-authenticator-text", as: "p" }, "Enter your email below and we will send a message to reset your password.")));
            },
        },
        ConfirmResetPassword: {
            Header: function () {
                return (React.createElement(Heading, { level: 3, className: "ov-authenticator-header" }, "Reset Password"));
            },
        },
    }); }, [logo]);
}
